import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IMultiUrlImage } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'cart-line-img',
  templateUrl: './cart-line-img.component.html',
  styleUrls: ['./cart-line-img.component.scss']
})
export class CartLineImgComponent implements AfterViewInit {
  @Input() public image: IMultiUrlImage;
  @Input() public alt: string = '';

  @ViewChild('imageWrap', { static: false }) public imageWrap: ElementRef;
  @ViewChild('imageRef', { static: false }) public imageRef: ElementRef;

  ngAfterViewInit() {
    this.imageWrap.nativeElement.classList.add('bg-cover-bla');
    this.imageRef.nativeElement.onload = () => {
      const { width, height } = this.imageRef.nativeElement;
      if (height / width < 0.8) {
        this.imageWrap.nativeElement.classList.add('bg-cover');
      }
    };
  }
}
